export default __webpack_public_path__ + "static/media/5.bb0f0ce1.jpg";